import { Button } from '@/shared/components/shadcn/button';
import { ToggleStage } from '@/shared/components/stage/toggle-stage';

type Props = {
  selectedCount: number;
  onSaveSelected: () => void;
  onClear: () => void;
};

export function BoardsSelectionActionBar({ selectedCount, onSaveSelected, onClear }: Props) {
  return (
    <ToggleStage
      status={selectedCount > 0}
      className="pointer-events-none fixed right-0 bottom-6 left-0 z-40 flex justify-center px-4"
    >
      <div className="border-border bg-background/95 pointer-events-auto flex items-center gap-3 rounded-full border px-4 py-3 shadow-lg backdrop-blur">
        <span className="text-sm font-medium">{selectedCount} selected</span>
        <Button size="sm" onClick={onSaveSelected}>
          Save to boards
        </Button>
        <Button size="sm" variant="outline" onClick={onClear}>
          Clear
        </Button>
      </div>
    </ToggleStage>
  );
}
